jQuery(function($){
    // reopen popup with fragment=id (find modal id or inner element with id)
    // check for form submit inside a popup and reopen
    if (location.hash && $(location.hash).closest('.modal').length) $(location.hash).closest('.modal').modal('toggle');
});
